import simpleStorage from '@/utils/simpleStorage'

const KEY = 'geoLocation'

export function setGeoLocation(geoLocation: string) {
  simpleStorage.set(KEY, geoLocation)
}

export function getGeoLocation() {
  return simpleStorage.get(KEY)
}
